export var ValidationErrorCode;
(function (ValidationErrorCode) {
    ValidationErrorCode["DeletePaidModuleWithBuyers"] = "0003";
})(ValidationErrorCode || (ValidationErrorCode = {}));
export class ApiError {
    constructor({ statusCode, message, headers, extra = {} }) {
        Object.defineProperty(this, "_message", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_statusCode", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_extra", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._statusCode = statusCode;
        this._message = message;
        this._extra = extra;
        this._headers = headers;
    }
    get statusCode() {
        return this._statusCode;
    }
    get message() {
        return this._message;
    }
    get headers() {
        return this._headers;
    }
    get extra() {
        return this._extra;
    }
}
export function isApiValidationError(data) {
    return data instanceof ApiError && typeof data?.extra?.errorCode === 'string';
}
